import { render, staticRenderFns } from "./WimexMaize.vue?vue&type=template&id=3154f2ff&scoped=true&lang=html&"
import script from "./WimexMaize.vue?vue&type=script&lang=js&"
export * from "./WimexMaize.vue?vue&type=script&lang=js&"
import style0 from "./WimexMaize.vue?vue&type=style&index=0&id=3154f2ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3154f2ff",
  null
  
)

export default component.exports